{
    "(save {highestYearlyDiscount}%)": "",
    "{amount} days free": "ฟรี {amount} วัน",
    "{amount} off": "ลด {amount}",
    "{amount} off for first {number} months.": "ลด {amount} สำหรับ {number} เดือนแรก",
    "{amount} off for first {period}.": "ลด {amount} สำหรับ {period} ไตรมาสแรก",
    "{amount} off forever.": "ลด {amount} ตลอดไป",
    "{buyerName} has gifted you a {duration}-month {tierName} membership to {siteTitle}_other": "",
    "{buyerName} has gifted you a {duration}-year {tierName} membership to {siteTitle}": "",
    "{discount}% discount": "ส่วนลด {discount}%",
    "{duration} membership": "",
    "{memberEmail} will no longer receive {newsletterName} newsletter.": "{memberEmail} นี้จะไม่ได้รับจดหมายข่าวจาก {newsletterName} อีกต่อไป",
    "{memberEmail} will no longer receive emails when someone replies to your comments.": "{memberEmail} จะไม่ได้รับอีเมลอีกต่อไป เมื่อมีคนตอบกลับความคิดเห็นของคุณ",
    "{memberEmail} will no longer receive this newsletter.": "{memberEmail} จะไม่ได้รับจดหมายข่าวนี้อีกต่อไป",
    "{memberEmail} will no longer receive updates & announcements.": "",
    "{months} month": "",
    "{months} months": "",
    "{months} months free": "",
    "{tierName} membership": "",
    "{trialDays} days free": "ฟรี {trialDays} วัน",
    "{years} years": "",
    "+1 (123) 456-7890": "",
    "1 month": "",
    "1 month free": "",
    "1 year": "",
    "A gift, just for you": "",
    "Access your RSS feeds": "",
    "Account": "บัญชี",
    "Account details updated successfully": "",
    "Account settings": "ตั้งค่าบัญชี",
    "Add a personal note": "",
    "Add a short note to go with your gift": "",
    "After a free trial ends, you will be charged the regular price for the tier you've chosen. You can always cancel before then.": "หลังจากช่วงทดลองใช้ฟรีสิ้นสุดลง, คุณจะถูกเรียกเก็บเงินตามราคาปกติตามระดับที่คุณเลือกไว้ คุณสามารถยกเลิกก่อนเวลาดังกล่าวได้เสมอ",
    "Already a member?": "เป็นสมาชิกอยู่แล้ว?",
    "An error occurred": "",
    "An unexpected error occured. Please try again or <a>contact support</a> if the error persists.": "เกิดข้อผิดพลาดที่ไม่คาดคิด โปรดลองอีกครั้งหรือ <a>ติดต่อฝ่ายสนับสนุน</a> หากข้อผิดพลาดยังคงอยู่",
    "Back": "ย้อนกลับ",
    "Back to Log in": "กลับไปยังเข้าสู่ระบบ",
    "Before you go": "",
    "Billing info & receipts": "",
    "Black Friday": "แบล็คฟรายเดย์",
    "Bluesky": "",
    "Cancel anytime.": "ยกเลิกได้ตลอดเวลา",
    "Cancel subscription": "ยกเลิกการรับสมัครข้อมูล",
    "Canceled": "",
    "Cancellation reason": "เหตุผลการยกเลิก",
    "Change": "เปลี่ยน",
    "Change plan": "",
    "Check spam & promotions folders": "ตรวจสอบโฟลเดอร์สแปมและโปรโมชัน",
    "Check with your mail provider": "ตรวจสอบกับผู้ให้บริการอีเมลของคุณ",
    "Check your inbox to verify email update": "",
    "Choose": "เลือก",
    "Choose a date from today onwards": "",
    "Choose a date within the next year": "",
    "Choose a delivery date": "",
    "Choose a different plan": "เลือกแผนอื่น",
    "Choose a plan": "",
    "Choose a tier": "",
    "Choose your newsletters": "เลือกอีเมลที่ต้องการรับจดหมายข่าว",
    "Click here to retry": "คลิกที่นี่เพื่อลองอีกครั้ง",
    "Click the confirmation link in your inbox to finish redeeming your membership. If it doesn't arrive within 3 minutes, check your spam folder.": "",
    "Close": "ปิด",
    "Code": "",
    "Comment preferences updated.": "",
    "Comments": "ความคิดเห็น",
    "Complimentary": "เพิ่มเติมฟรีโดยไม่คิดค่าใช้จ่าย",
    "Confirm": "ยืนยัน",
    "Confirm cancellation": "ยืนยันการยกเลิก",
    "Confirm subscription": "ยืนยันการรับสมัครข้อมูล",
    "Contact support": "ติดต่อฝ่ายสนับสนุน",
    "Continue": "ดำเนินการต่อ",
    "Continue subscription": "รับสมัครข้อมูลต่อ",
    "Continue to delivery details": "",
    "Continue to payment": "",
    "Continue with a paid subscription anytime. Your remaining gift period will be added as a free trial.": "",
    "Copied": "",
    "Copy": "",
    "Copy link": "",
    "Could not create Stripe billing portal session": "",
    "Could not create Stripe checkout session": "",
    "Could not sign in. Login link expired.": "ไม่สามารถลงชื่อเข้าใช้ได้ ลิงก์เข้าสู่ระบบหมดอายุ",
    "Could not update email! Invalid link.": "ไม่สามารถอัปเดตอีเมลได้! ลิงก์ไม่ถูกต้อง",
    "Create a new contact": "สร้างผู้ติดต่อใหม่",
    "Current plan": "แผนปัจจุบัน",
    "Delete account": "ลบบัญชี",
    "Delivery date": "",
    "Delivery method": "",
    "Didn't mean to do this? Manage your preferences <button>here</button>.": "ไม่ได้ตั้งใจที่จะทำเช่นนี้? จัดการการตั้งค่าของคุณ<button>ที่นี่</button>",
    "Don't have an account?": "ยังไม่มีบัญชี?",
    "Edit": "แก้ไข",
    "Email": "อีเมล",
    "Email confirmation link expired.": "",
    "Email it to them": "",
    "Email newsletter": "จดหมายข่าวทางอีเมล",
    "Email newsletter settings updated": "",
    "Email preferences": "การตั้งค่าอีเมล",
    "Email preferences updated.": "",
    "Emails": "อีเมล",
    "Emails disabled": "อีเมลถูกปิดใช้งาน",
    "Ends {offerEndDate}": "สิ้นสุด {offerEndDate}",
    "Enjoy {amountOff} off forever.": "",
    "Enjoy {months} free months on us.": "",
    "Enjoy {months} free months on us. You won't be charged until {newBillingDate}.": "",
    "Enjoy a free month on us.": "",
    "Enjoy a free month on us. You won't be charged until {newBillingDate}.": "",
    "Enter code above": "",
    "Enter the recipient's email address": "",
    "Enter your email address": "",
    "Enter your name": "",
    "Error": "ข้อผิดพลาด",
    "Expires {expiryDate}": "หมดอายุ {expiryDate}",
    "Facebook": "",
    "Failed to cancel subscription, please try again": "",
    "Failed to log in, please try again": "",
    "Failed to log out, please try again": "",
    "Failed to open billing portal, please try again": "",
    "Failed to process checkout, please try again": "",
    "Failed to send magic link email": "",
    "Failed to send verification email": "",
    "Failed to sign up, please try again": "",
    "Failed to update account data": "",
    "Failed to update account details": "",
    "Failed to update billing information, please try again": "",
    "Failed to update newsletter settings": "",
    "Failed to update subscription, please try again": "",
    "Failed to verify code, please try again": "",
    "Forever": "ตลอดไป",
    "Free Trial – Ends {trialEnd}": "ทดลองใช้ฟรี - สิ้นสุด {trialEnd}",
    "From": "",
    "Get help": "ต้องการความช่วยเหลือ",
    "Get in touch for help": "ติดต่อขอความช่วยเหลือ",
    "Get notified when someone replies to your comment": "รับการแจ้งเตือนเมื่อมีคนตอบกลับความคิดเห็นของคุณ",
    "Gift a membership": "",
    "Gift could not be redeemed": "",
    "Gift details": "",
    "Gift duration": "",
    "Gift link copied to clipboard": "",
    "Gift redeemed! You're all set.": "",
    "Gift subscription": "",
    "Gift subscriptions are not available right now.": "",
    "Gift value": "",
    "Give feedback on this post": "ให้ข้อเสนอแนะเกี่ยวกับโพสต์นี้",
    "Help! I'm not receiving emails": "ช่วยด้วย! ฉันไม่ได้รับอีเมล",
    "Here are a few other sites you may enjoy.": "นี่คือเว็บอื่นๆ บางส่วนที่คุณอาจชอบ",
    "Hi {recipientName},": "",
    "Hide details": "",
    "How would you like to share this gift?": "",
    "I'll share it myself": "",
    "If a newsletter is flagged as spam, emails are automatically disabled for that address to make sure you no longer receive any unwanted messages.": "หากจดหมายข่าวถูกทำเครื่องหมายว่าเป็นสแปม อีเมลจะถูกปิดใช้งานโดยอัตโนมัติสำหรับที่อยู่นั้น เพื่อให้แน่ใจว่าคุณจะไม่ได้รับข้อความที่ไม่ต้องการอีกต่อไป",
    "If the spam complaint was accidental, or you would like to begin receiving emails again, you can resubscribe to emails by clicking the button on the previous screen.": "หากการร้องเรียนเกี่ยวกับสแปมเกิดขึ้นโดยไม่ได้ตั้งใจ หรือคุณต้องการเริ่มรับอีเมลอีกครั้ง คุณสามารถสมัครรับอีเมลอีกครั้งโดยคลิกที่ปุ่มบนหน้าจอก่อนหน้า",
    "If you cancel your subscription now, you will continue to have access until {periodEnd}.": "หากคุณยกเลิกการรับสมัครข้อมูลตอนนี้, คุณจะยังสามารถเข้าถึงได้ต่อไปจนถึง {periodEnd}",
    "If you have a corporate or government email account, reach out to your IT department and ask them to allow emails to be received from {senderEmail}": "หากคุณมีบัญชีอีเมลของบริษัทหรือภาครัฐ โปรดติดต่อแผนกไอทีของคุณและขอให้พวกเขาอนุญาตให้รับอีเมลจาก {senderEmail}",
    "If you have an account, a login link has been sent to your inbox. If it doesn't arrive in 3 minutes, be sure to check your spam folder.": "ลิงค์เข้าสู่ระบบถูกส่งไปยังกล่องจดหมายของคุณแล้ว หากไม่ได้รับภายใน 3 นาที โปรดตรวจสอบโฟลเดอร์สแปมของคุณ",
    "If you have an account, an email has been sent to {submittedEmailOrInbox}. Click the link inside or enter your code below.": "",
    "If you would like to start receiving emails again, the best next steps are to check your email address on file for any issues and then click resubscribe on the previous screen.": "หากคุณต้องการเริ่มรับอีเมลอีกครั้ง ขั้นตอนถัดไปที่ดีที่สุดคือตรวจสอบที่อยู่อีเมลของคุณในระบบเพื่อดูปัญหาใดๆ หรือไม่ จากนั้นคลิกรับสมัครข้อมูลใหม่บนหน้าจอก่อนหน้า",
    "If you're not receiving the email newsletter you've subscribed to, here are a few things to check.": "หากคุณไม่ได้รับจดหมายข่าวทางอีเมลที่คุณสมัครรับข้อมูล โปรดตรวจสอบรายการต่อไปนี้",
    "If you've completed all these checks and you're still not receiving emails, you can reach out to get support by contacting {supportAddress}.": "หากคุณตรวจสอบทั้งหมดนี้แล้ว แต่ยังไม่ได้รับอีเมล คุณสามารถติดต่อเพื่อแก้ไขปัญหาได้โดยติดต่อ {supportAddress}",
    "In the event a permanent failure is received when attempting to send a newsletter, emails will be disabled on the account.": "ในกรณีที่พยายามส่งจดหมายข่าวและได้รับความล้มเหลวอย่างถาวร, ที่อยู่อีเมลจะถูกปิดการใช้งานจากบัญชี",
    "In your email client add {senderEmail} to your contacts list. This signals to your mail provider that emails sent from this address should be trusted.": "ในโปรแกรมรับส่งอีเมลของคุณ ให้เพิ่ม {senderEmail} ลงในรายชื่อผู้ติดต่อของคุณ นี่เป็นการส่งสัญญาณไปยังผู้ให้บริการอีเมลของคุณ ว่าอีเมลที่ส่งจากที่อยู่นี้เชื่อถือได้",
    "Invalid email address": "",
    "Invalid verification code": "",
    "Jamie Larson": "",
    "jamie@example.com": "",
    "Less like this": "เห็นแบบนี้ให้น้อยลง",
    "LinkedIn": "",
    "Make sure emails aren't accidentally ending up in the Spam or Promotions folders of your inbox. If they are, click on \"Mark as not spam\" and/or \"Move to inbox\".": "ตรวจสอบให้แน่ใจว่าอีเมลไม่ได้ไปอยู่ในโฟลเดอร์สแปมหรือโปรโมชั่นในกล่องจดหมายของคุณโดยไม่ได้ตั้งใจ หากเป็นเช่นนั้น ให้คลิก \"ทำเครื่องหมายว่าไม่ใช่สแปม\" และ/หรือ \"ย้ายไปที่กล่องจดหมาย\"",
    "Manage": "จัดการ",
    "Maybe later": "ไว้ก่อน",
    "Membership details": "",
    "Memberships from this email domain are currently restricted.": "",
    "Memberships unavailable, contact the owner for access.": "การเป็นสมาชิกไม่พร้อมใช้งาน, โปรดติดต่อเจ้าของเพื่อขอสิทธิ์ในการเข้าถึง",
    "month": "",
    "Monthly": "รายเดือน",
    "More like this": "เห็นแบบนี้ให้มากขึ้น",
    "More options": "",
    "Name": "ชื่อ",
    "Need more help? Contact support": "ต้องการความช่วยเหลือเพิ่มเติม? ติดต่อฝ่ายสนับสนุน",
    "Newsletters can be disabled on your account for two reasons: A previous email was marked as spam, or attempting to send an email resulted in a permanent failure (bounce).": "จดหมายข่าวสามารถปิดการใช้งานในบัญชีของคุณด้วยเหตุผลสองประการ: อีเมลก่อนหน้านี้ถูกทำเครื่องหมายว่าเป็นสแปม หรือการพยายามที่ส่งอีเมล ส่งผลให้เกิดความล้มเหลวถาวร (อีเมลตีกลับ)",
    "No member exists with this e-mail address.": "",
    "No thanks, I want to cancel": "",
    "Not ready to share? We've also emailed a copy to your inbox.": "",
    "Not receiving emails?": "ไม่ได้รับอีเมล?",
    "Now": "",
    "Now check your email!": "ตรวจสอบอีเมลของคุณตอนนี้!",
    "Occasional updates from {siteTitle}": "",
    "Once resubscribed, if you still don't see emails in your inbox, check your spam folder. Some inbox providers keep a record of previous spam complaints and will continue to flag emails. If this happens, mark the latest newsletter as 'Not spam' to move it back to your primary inbox.": "เมื่อรับสมัครข้อมูลใหม่แล้ว, หากคุณยังคงไม่เห็นอีเมลในกล่องจดหมายของคุณ ให้ตรวจสอบโฟลเดอร์สแปมของคุณ. ผู้ให้บริการกล่องจดหมายบางราย เก็บบันทึกการร้องเรียนเกี่ยวกับสแปมก่อนหน้านี้ และจะทำการตั้งค่าสถานะอีเมลต่อไป หากเกิดเหตุการณ์เช่นนี้ ให้ทำเครื่องหมายจดหมายข่าวล่าสุดว่า 'ไม่ใช่สแปม' เพื่อย้ายกลับไปยังกล่องจดหมายหลักของคุณ",
    "Open AOL Mail": "",
    "Open email": "",
    "Open Feedbin": "",
    "Open Gmail": "",
    "Open Hey": "",
    "Open iCloud Mail": "",
    "Open Mail.ru": "",
    "Open Outlook": "",
    "Open Proton Mail": "",
    "Open Yahoo Mail": "",
    "Optional message": "",
    "Permanent failure (bounce)": "ความล้มเหลวอย่างถาวร (อีเมลถูกตีกลับ)",
    "Phone number": "",
    "Plan": "แผน",
    "Plan checkout was cancelled.": "การชำระเงินตามแผนถูกยกเลิก",
    "Plan upgrade was cancelled.": "การอัปเกรดแผนถูกยกเลิก",
    "Please contact {supportAddress} to adjust your complimentary subscription.": "โปรดติดต่อ {supportAddress} เพื่อปรับเปลี่ยนการรับสมัครข้อมูลฟรีของคุณ",
    "Please enter {fieldName}": "",
    "Please fill in required fields": "กรุณากรอกข้อมูลในช่องให้ครบถ้วน",
    "Podcasts": "",
    "Re-enable emails": "เปิดใช้งานอีเมลนี้อีกครั้ง",
    "Recipient's email": "",
    "Recipient's name": "",
    "Recommendations": "รายการแนะนำ",
    "Redeem your gift": "",
    "Redeem your membership": "",
    "Redeeming...": "",
    "Renews at {price}.": "ต่ออายุที่ {price}",
    "Resume subscription": "",
    "Retry": "ลองอีกครั้ง",
    "Save": "บันทึก",
    "Save {amountOff} on your next {durationInMonths} billing cycles. Then {currency}{originalPrice}/{cadence}.": "",
    "Save {amountOff} on your next billing cycle. Then {currency}{originalPrice}/{cadence}.": "",
    "Send the link below to share it with whoever you'd like.": "",
    "Sending login link...": "กำลังส่งลิงก์เข้าสู่ระบบ...",
    "Sending...": "กำลังส่ง...",
    "Share": "",
    "Share a full membership to {siteTitle} with a friend or colleague": "",
    "Share it yourself": "",
    "Show all": "แสดงทั้งหมด",
    "Sign in": "ลงชื่อเข้าใช้",
    "Sign out": "ออกจากระบบ",
    "Sign up": "สมัครใช้งาน",
    "Signup error: Invalid link": "มีข้อผิดพลาดในการสมัครใช้งาน: ลิงก์ไม่ถูกต้อง",
    "Signups from this email domain are currently restricted.": "",
    "Something went wrong, please try again later.": "",
    "Sorry, no paid plans are available.": "",
    "Sorry, no recommendations are available right now.": "",
    "Sorry, that didn’t work.": "ขออภัย, ไม่สามารถส่งได้",
    "Spam complaints": "การร้องเรียนเกี่ยวกับสแปม",
    "Start {amount}-day free trial": "เริ่มทดลองใช้ฟรี {amount} วัน",
    "Starting {startDate}": "เริ่มวันที่ {startDate}",
    "Starting today": "เริ่มตั้งแต่วันนี้เป็นต้นไป",
    "Submit feedback": "ส่งข้อเสนอแนะ",
    "Subscribe": "รับสมัครข้อมูล",
    "Subscribed": "รับสมัครข้อมูลแล้ว",
    "Subscription plan updated successfully": "",
    "Success": "สำเร็จ",
    "Success! Check your email for magic link to sign-in.": "สำเร็จ! ตรวจสอบอีเมลของคุณเพื่อดูลิงก์วิเศษสำหรับลงชื่อเข้าใช้",
    "Success! Your account is fully activated, you now have access to all content.": "สำเร็จ! บัญชีของคุณเปิดใช้งานโดยสมบูรณ์แล้ว ตอนนี้คุณสามารถเข้าถึงเนื้อหาทั้งหมดได้แล้ว",
    "Success! Your email is updated.": "อัปเดตอีเมลสำเร็จแล้ว!",
    "Successfully unsubscribed": "ยกเลิกการรับสมัครข้อมูลเรียบร้อยแล้ว",
    "Taylor Reid": "",
    "taylor@example.com": "",
    "Thank you for subscribing. Before you start reading, below are a few other sites you may enjoy.": "ขอบคุณสำหรับการรับสมัครข้อมูล ก่อนที่คุณจะเริ่มอ่าน ด้านล่างนี้คือเว็บไซต์อื่นๆ บางส่วนที่คุณอาจชอบ",
    "Thank you for your support": "",
    "Thank you for your support!": "",
    "Thanks for the feedback!": "ขอบคุณสำหรับความคิดเห็น!",
    "That didn't go to plan": "บางอย่างไม่เป็นไปตามแผน",
    "The email address we have for you is {memberEmail} — if that's not correct, you can update it in your <button>account settings area</button>.": "ที่อยู่อีเมลของคุณที่เรามีคือ {memberEmail} — หากไม่ถูกต้อง คุณสามารถอัปเดตได้ใน<button>พื้นที่การตั้งค่าบัญชี</button>",
    "There was a problem submitting your feedback. Please try again a little later.": "เกิดปัญหาในการส่งความคิดเห็นของคุณ โปรดลองอีกครั้งในภายหลัง",
    "There was an error cancelling your subscription, please try again.": "",
    "There was an error continuing your subscription, please try again.": "",
    "There was an error processing your payment. Please try again.": "",
    "There was an error sending the email, please try again": "",
    "This gift can only be redeemed once and expires on {expiryDate}.": "",
    "This gift has already been consumed.": "",
    "This gift has already been redeemed.": "",
    "This gift has been refunded.": "",
    "This gift has expired.": "",
    "This gift link is invalid.": "",
    "This site is invite-only, contact the owner for access.": "เว็บไซต์นี้สำหรับผู้ได้รับเชิญเท่านั้น โปรดติดต่อเจ้าของเพื่อเข้าถึง",
    "This site is not accepting donations at the moment.": "",
    "This site is not accepting payments at the moment.": "",
    "This site only accepts paid members.": "",
    "Threads": "",
    "Tier": "",
    "To": "",
    "To complete signup, click the confirmation link in your inbox. If it doesn't arrive within 3 minutes, check your spam folder!": "เพื่อทำการลงทะเบียนให้เสร็จสิ้น คลิกลิงก์ยืนยันในกล่องจดหมายของคุณ หากไม่ได้รับภายใน 3 นาที ให้ตรวจสอบโฟลเดอร์สแปมของคุณ!",
    "To continue to stay up to date, subscribe to {publication} below.": "",
    "Too many attempts try again in {number} days.": "",
    "Too many attempts try again in {number} hours.": "",
    "Too many attempts try again in {number} minutes.": "",
    "Too many different sign-in attempts, try again in {number} days": "",
    "Too many different sign-in attempts, try again in {number} hours": "",
    "Too many different sign-in attempts, try again in {number} minutes": "",
    "Too many sign-up attempts, try again later": "",
    "Try free for {amount} days, then {originalPrice}.": "ทดลองใช้ฟรี {amount} วัน จากนั้นจ่ายเป็น {originalPrice}",
    "Unable to initiate checkout session": "",
    "Unlock access to all newsletters by becoming a paid subscriber.": "ปลดล็อกการเข้าถึงจดหมายข่าวทั้งหมดโดยสมัครเป็นสมาชิกแบบชำระเงิน",
    "Unsubscribe from all emails": "ยกเลิกการรับสมัครข้อมูลทางอีเมลทั้งหมด",
    "Unsubscribed": "ยกเลิกการรับสมัครข้อมูลทางอีเมลแล้ว",
    "Unsubscribed from all emails.": "",
    "Unsubscribing from emails will not cancel your paid subscription to {title}": "การยกเลิกการสมัครรับอีเมล จะไม่ยกเลิกการรับสมัครข้อมูลแบบชำระเงินของคุณกับ {title}",
    "Update": "อัปเดต",
    "Update your preferences": "อัปเดตการตั้งค่าของคุณ",
    "Updates & announcements": "",
    "Verification link sent, check your inbox": "ส่งลิงก์ยืนยันแล้ว โปรดตรวจสอบกล่องจดหมายของคุณ",
    "Verify your email address is correct": "โปรดตรวจสอบที่อยู่อีเมลของคุณให้ถูกต้อง",
    "Verifying...": "",
    "View plans": "ดูแผน",
    "We couldn't unsubscribe you as the email address was not found. Please contact the site owner.": "เราไม่สามารถยกเลิกการรับสมัครข้อมูลของคุณได้ เนื่องจากไม่พบที่อยู่อีเมล โปรดติดต่อเจ้าของเว็บไซต์",
    "We'd hate to see you leave. How about a special offer to stay?": "",
    "We'll email it to the recipient on {deliveryDate}. A copy is in your inbox too.": "",
    "We'll email it to the recipient. A copy will be in your inbox too.": "",
    "Welcome back, {name}!": "ยินดีต้อนรับกลับมา, {name}!",
    "Welcome back!": "ยินดีต้อนรับกลับ!",
    "Welcome to {siteTitle}": "ยินดีต้อนรับสู่ {siteTitle}",
    "What's included": "",
    "When an inbox fails to accept an email it is commonly called a bounce. In many cases, this can be temporary. However, in some cases, a bounced email can be returned as a permanent failure when an email address is invalid or non-existent.": "เมื่อกล่องจดหมายเข้าไม่ยอมรับอีเมล โดยทั่วไปจะเรียกว่าการตีกลับ. ในหลายกรณี, การดำเนินการนี้อาจเกิดขึ้นชั่วคราว. อย่างไรก็ตาม ในบางกรณี อีเมลที่ถูกตีกลับ สามารถส่งคืนเป็นความล้มเหลวถาวรเมื่อที่อยู่อีเมลไม่ถูกต้องหรือไม่มีอยู่จริง",
    "Why has my email been disabled?": "เหตุใดอีเมลของฉันจึงถูกปิดการใช้งาน?",
    "X (Twitter)": "",
    "year": "",
    "Yearly": "รายปี",
    "You already have an active subscription.": "",
    "You currently have a free membership, upgrade to a paid subscription for full access.": "ขณะนี้คุณเป็นสมาชิกฟรี, อัปเกรดเป็นการรับสมัครข้อมูลแบบชำระเงินเพื่อการเข้าถึงเต็มรูปแบบ",
    "You have been successfully resubscribed": "คุณรับสมัครข้อมูลทางอีเมลอีกครั้งสำเร็จแล้ว",
    "You now have access to {tierName} until {expiryDate}. Enjoy!": "",
    "You're currently not receiving emails": "ขณะนี้คุณไม่ได้รับข่าวสารทางอีเมล",
    "You're not receiving emails": "คุณไม่ได้รับอีเมล",
    "You're not receiving emails because you either marked a recent message as spam, or because messages could not be delivered to your provided email address.": "คุณไม่ได้รับอีเมล เนื่องจากคุณทำเครื่องหมายข้อความล่าสุดว่าเป็นสแปม, หรือเนื่องจากไม่สามารถส่งข้อความไปยังที่อยู่อีเมลที่คุณให้ไว้",
    "You've been gifted a {duration}-month {tierName} membership_other": "",
    "You've been gifted a {duration}-month {tierName} membership to {siteTitle}_other": "",
    "You've been gifted a {duration}-year {tierName} membership": "",
    "You've been gifted a {duration}-year {tierName} membership to {siteTitle}": "",
    "You've been gifted a membership": "",
    "You've been gifted a membership to {siteTitle}": "",
    "You've successfully signed in.": "คุณลงชื่อเข้าใช้สำเร็จแล้ว",
    "You've successfully subscribed to <strong>{siteTitle}</strong>": "คุณรับสมัครข้อมูลสำเร็จแล้ว <strong>{siteTitle}</strong>",
    "Your account": "บัญชีของคุณ",
    "Your email": "",
    "Your email has failed to resubscribe, please try again": "",
    "Your gift is on its way": "",
    "Your gift is ready": "",
    "Your gift is scheduled": "",
    "Your gift subscription will expire on {expiryDate}": "",
    "your inbox": "",
    "Your input helps shape what gets published.": "ข้อมูลของคุณ จะช่วยกำหนดสิ่งที่จะได้รับการเผยแพร่ในอนาคต",
    "Your name": "",
    "Your subscription has been canceled and will expire on {expiryDate}.": "",
    "Your subscription will expire on {expiryDate}": "การรับสมัครข้อมูลของคุณจะหมดอายุในวันที่ {expiryDate}",
    "Your subscription will renew on {renewalDate}": "การรับสมัครข้อมูลของคุณจะต่ออายุในวันที่ {renewalDate}",
    "Your subscription will start on {subscriptionStart}": "การรับสมัครข้อมูลของคุณจะเริ่มในวันที่ {subscriptionStart}"
}
